/* A Levey-Jennings chart (the dataviz conventions): one token hue for the series, a 2px line,
   markers of at least 10px with a surface ring, recessive SD lines in border tokens, text in
   text tokens, never the series colour. Tokens only, so every theme and dark mode follow. */

.figure {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
  margin: 0;
}

.caption {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  color: var(--graphite);
  font: var(--t-small);
}

.title {
  margin-right: var(--space-2);
  color: var(--ink);
  font: var(--t-body-strong);
}

.target {
  color: var(--graphite);
  font-variant-numeric: tabular-nums;
}

.readout {
  min-height: 18px;
  margin: 0;
  color: var(--ink);
  font: var(--t-small);
  font-variant-numeric: tabular-nums;
}

.plot {
  display: block;
  width: 100%;
  height: auto;
  max-height: 260px;
  overflow: visible;
}

.mean {
  stroke: var(--graphite);
  stroke-width: 1.5;
}

.sd1 {
  stroke: var(--border);
  stroke-width: 1;
}

.sd2 {
  stroke: var(--border-strong);
  stroke-dasharray: 6 4;
  stroke-width: 1;
}

.sd3 {
  stroke: var(--pencil);
  stroke-dasharray: 2 3;
  stroke-width: 1;
}

.axis {
  fill: var(--graphite);
  font: var(--t-micro);
  font-variant-numeric: tabular-nums;
}

.line {
  fill: none;
  stroke: var(--color-primary);
  stroke-linejoin: round;
  stroke-width: 2;
}

.hit {
  fill: transparent;
}

.accepted,
.warning {
  fill: var(--color-primary);
  stroke: var(--paper);
  stroke-width: 2;
}

.rejected {
  fill: var(--paper);
  stroke: var(--ink);
  stroke-width: 2.5;
}

.point {
  cursor: default;
  outline: none;
}

.point:focus-visible .hit {
  stroke: var(--color-primary);
  stroke-width: 2;
}

.point[data-active='true'] .accepted,
.point[data-active='true'] .warning {
  fill: var(--color-primary-hover);
}
